<template lang="pug">
    .animation(ref='animation')
        .papers
            .paper(v-for='item in 6' ref='paper')
                img(src='../../assets/img/animations/paper-3.svg')

</template>
<script>
import {gsap} from 'gsap';
import {mixinAnimation} from '../mixins/mixinAnimation';

export default {
    mixins: [mixinAnimation],
    methods: {
        createAnimation() {
            this.createTimeline();
            this.createScroll('bottom-bottom', 'bottom-top');
        },
        createTimeline() {
            this.timeline = gsap.timeline({paused: true});
            this.timeline.fromTo(
                this.$refs.paper,
                {x: 0, y: 0, rotate: 0},
                {
                    duration: 4,
                    x: 'random(300, 500)%',
                    y: 'random(-200, -100)%',
                    rotate: 'random(50, 300)',
                    transformOrigin: 'random(20, 80)% random(20, 80)%',
                    stagger: {each: 1, from: 'end'}
                },
                0
            );
            this.timeline.progress(0.0001);
            this.timeline.pause();
        }
    }
};
</script>
<style lang="scss" scoped>
.animation {
    display: flex;
    align-items: center;
    justify-content: center;
    @media (--viewport-tablet) {
        padding: var(--grid-column-mobile) 0;
    }
}
.papers {
    position: relative;
}
.paper:not(:first-child) {
    position: absolute;
    top: 0;
    left: 0;
}
</style>
